import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { lookupGuestOrder, findGuestOrderNumber } from '../../services/api';

function GuestOrderLookup({ activeTab, setActiveTab }) {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const [guestData, setGuestData] = useState({ orderNumber: '', phoneNumber: '' });
  const [findOrderData, setFindOrderData] = useState({ name: '', phone: '', email: '' });
  const [foundOrderNumbers, setFoundOrderNumbers] = useState([]);

  const handleGuestChange = (e) => setGuestData({ ...guestData, [e.target.name]: e.target.value });
  const handleFindOrderChange = (e) => setFindOrderData({ ...findOrderData, [e.target.name]: e.target.value });

  const inputClass = "appearance-none relative block w-full px-4 py-3 border border-gray-300 dark:border-gray-700 placeholder-gray-400 text-gray-900 dark:text-white dark:bg-[#0d1b12] rounded-xl focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary focus:z-10 sm:text-sm transition-colors";
  const btnClass = "group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-bold rounded-xl text-white bg-gray-800 hover:bg-gray-700 dark:bg-gray-700 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-all disabled:opacity-70 disabled:cursor-not-allowed";

  const handleGuestSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await lookupGuestOrder(guestData.orderNumber, guestData.phoneNumber);
      if (response.data) {
        navigate(`/order/detail/${response.data.id}`, { state: { guestOrder: response.data } });
      } else {
        setError('주문 내역을 찾을 수 없습니다.');
      }
    } catch {
      setError('주문 조회에 실패했습니다. 주문번호와 연락처를 확인해주세요.');
    } finally {
      setLoading(false);
    }
  };

  const handleFindOrderSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setFoundOrderNumbers([]);
    setLoading(true);
    try {
      const response = await findGuestOrderNumber(findOrderData);
      if (response.data?.count > 0) {
        setFoundOrderNumbers(response.data.orderNumbers);
      } else {
        setError('일치하는 주문 내역이 없습니다.');
      }
    } catch {
      setError('주문 번호 찾기에 실패했습니다. 입력 정보를 확인해주세요.');
    } finally {
      setLoading(false);
    }
  };

  const ErrorMessage = () => error ? (
    <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-600 dark:text-red-400 px-4 py-3 rounded-xl text-sm text-center">
      {error}
    </div>
  ) : null;

  if (activeTab === 'guest') {
    return (
      <form className="mt-8 space-y-6" onSubmit={handleGuestSubmit}>
        <ErrorMessage />
        <div className="space-y-4">
          <div>
            <label htmlFor="orderNumber" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">주문번호</label>
            <input id="orderNumber" name="orderNumber" type="text" required className={inputClass} placeholder="주문 완료 시 발송된 주문번호" value={guestData.orderNumber} onChange={handleGuestChange} />
          </div>
          <div>
            <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">연락처</label>
            <input id="phoneNumber" name="phoneNumber" type="tel" required className={inputClass} placeholder="주문 시 입력한 휴대폰 번호 (-없이 입력)" value={guestData.phoneNumber} onChange={handleGuestChange} />
          </div>
        </div>
        <div>
          <button type="submit" disabled={loading} className={btnClass}>
            {loading ? "조회 중..." : "비회원 주문 조회"}
          </button>
        </div>
        <div className="flex flex-col items-center gap-4 text-sm mt-4">
          <button type="button" onClick={() => { setActiveTab('findOrder'); setError(''); }} className="text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 underline">
            주문번호를 잊으셨나요?
          </button>
          <Link to="/" className="font-medium text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors">
            ← 홈으로 돌아가기
          </Link>
        </div>
      </form>
    );
  }

  if (activeTab === 'findOrder') {
    return (
      <form className="mt-8 space-y-6" onSubmit={handleFindOrderSubmit}>
        <ErrorMessage />
        {foundOrderNumbers.length > 0 ? (
          <div className="text-center py-6 bg-green-50 dark:bg-green-900/20 rounded-xl border border-green-100 dark:border-green-800">
            <h3 className="text-lg font-bold text-green-800 dark:text-green-400 mb-4">찾은 주문번호</h3>
            <ul className="mb-6 space-y-2">
              {foundOrderNumbers.map((num, idx) => (
                <li key={idx} className="text-xl font-black text-[#0d1b12] dark:text-white font-mono">{num}</li>
              ))}
            </ul>
            <button type="button" className="px-6 py-2 bg-primary text-primary-contrast font-bold rounded-lg hover:opacity-90 shadow-lg"
              onClick={() => { setActiveTab('guest'); setGuestData({ ...guestData, orderNumber: foundOrderNumbers[0] }); }}>
              주문 조회하러 가기
            </button>
          </div>
        ) : (
          <>
            <div className="space-y-4">
              <div>
                <label htmlFor="findName" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">주문자 이름</label>
                <input id="findName" name="name" type="text" required className={inputClass} placeholder="주문자 이름을 입력하세요" value={findOrderData.name} onChange={handleFindOrderChange} />
              </div>
              <div>
                <label htmlFor="findPhone" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">연락처</label>
                <input id="findPhone" name="phone" type="tel" required className={inputClass} placeholder="휴대폰 번호 (-없이 입력)" value={findOrderData.phone} onChange={handleFindOrderChange} />
              </div>
              <div>
                <label htmlFor="findEmail" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">이메일</label>
                <input id="findEmail" name="email" type="email" required className={inputClass} placeholder="주문 시 입력한 이메일" value={findOrderData.email} onChange={handleFindOrderChange} />
              </div>
            </div>
            <button type="submit" disabled={loading} className={btnClass}>
              {loading ? "찾는 중..." : "주문번호 찾기"}
            </button>
          </>
        )}
        <div className="flex justify-center mt-4">
          <button type="button" onClick={() => { setActiveTab('guest'); setError(''); }} className="text-sm text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 underline">
            돌아가기
          </button>
        </div>
      </form>
    );
  }

  return null;
}

export default GuestOrderLookup;
